import React, { useEffect, useContext, useState, useRef } from "react";
import { TokenVerificationLoggedin, BlockAdmin } from "../../utils/tokenVerify";
import { LoadingContext } from "react-router-loading";
import axios from "axios";
import Cookies from "js-cookie";
import configData from "../../config/config.json";
import { Table, Tooltip, Select, Col, Row, Pagination, Input, Modal } from 'antd';
import { Link } from 'react-router-dom'
import FullLoader from "../../assets/images/full-page-loader.gif"
import prevIcon from '../../assets/images/icons/chevron-left.svg';
import nextIcon from '../../assets/images/icons/chevron-right.svg';
import noData from '../../assets/images/data-graph/no-data.svg';
import TableLoader from "../TableLoader";
import errorData from '../../assets/images/data-graph/error-data.svg';
import { saveAs } from "file-saver";
import { notifyfailure, notifysuccess } from "../../utils/toast";
import mediaKitIcon from '../../assets/images/icons/download_gray_icon.svg';
import domainInfo from '../../assets/images/icons/domain_info.svg';
import macrosicon from '../../assets/images/icons/macros_modal_icon.svg';


const AdminDomainList = () => {

    const loadingContext = useContext(LoadingContext);
    const [apiCall, setApicall] = useState(false)
    // const [colvis, setColvis] = useState({
    //     "z_cate": true,
    //     "invent_type": true,
    //     "p_name": true,
    //     "createdAt": true
    // })

    const columnsAll = [
        {
            title: 'Action',
            dataIndex: 'action',
            width: 50,
            fixed: 'left',
            render: (text, record) => {
                return (

                    <div className='btn_group'
                    >
                        <>
                            {record?.downloadLoading ?

                                <button className="new_integrate_btn_d2 btn btn_primary loader loader_btn_with_icon">
                                    <span> Download</span>
                                    <img src={FullLoader} alt="USP" className="" />
                                </button>
                                :
                                <Tooltip title="Download">
                                    <button className='download_icon download_icon_d2'
                                        onClick={() => {
                                            handleDownload(record._id, record.name)
                                        }}
                                    >
                                        <img src={mediaKitIcon} alt='USP' />
                                    </button>
                                </Tooltip>
                            }
                        </>
                        {record.result !== undefined && Object.keys(record.result).length > 0 ?
                            <Tooltip title="Domain Details">
                                <button className='download_icon download_icon_d2'
                                    onClick={() => {
                                        setDataInfoModal(record.result)
                                        setIsModalVisible(true)

                                    }}
                                >
                                    <img src={domainInfo} alt='USP' /></button>
                            </Tooltip>
                            :
                            <button className='info_button_disable'

                            >
                                <img src={domainInfo} alt='USP' style={{ opacity: "0.4" }} /></button>
                        }
                    </div>
                )
            },
        },

        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: 95,
            fixed: 'left',
            render: (text) => {
                return (
                    <>
                        <div className='w_100'>
                            {text === "Processed" ?
                                <button className='badge_content_fixed--approved'>
                                    {text}
                                </button>
                                :
                                <button className='badge_content_fixed--declined'> {text}</button>
                            }
                        </div>

                    </>
                )
            }
        },


        {
            title: "Name",
            dataIndex: "name",
            width: 250,
            key: "name",
            fixed: 'left',
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (text) => {

                return (
                    <div >
                        {(text === "" || text === undefined || text === null) ?
                            <>
                                <div className='text_dark'>-</div>
                            </>
                            :
                            <>
                                {((text?.length || 0)) >= 40 ? (
                                    <Tooltip title={text}>
                                        {text?.slice(0, 40)} ...
                                    </Tooltip>
                                ) : (
                                    <>{text}</>
                                )}
                            </>

                        }
                    </div>
                )
            },
        },
        {
            title: "Uploaded By",
            dataIndex: "uploadedBy",
            width: 180,
            key: "uploadedBy",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
        },
        {
            title: "Publisher",
            dataIndex: "publisherId",
            width: 200,
            key: "publisherId",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (text) => {
                return (
                    <div >
                        {(text === "" || text === undefined || text === null) ?
                            <>
                                <div className='text_dark'>-</div>
                            </>
                            :
                            <>
                                {((text?.length || 0)) >= 38 ? (
                                    <Tooltip title={text}>
                                        {text?.slice(0, 38)} ...
                                    </Tooltip>
                                ) : (
                                    <>{text}</>
                                )}
                            </>

                        }
                    </div>
                )
            },
        },
        {
            title: "Created At",
            dataIndex: "createdAt",
            width: 150,
            key: "createdAt",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
        },
        {
            title: "Updated At",
            dataIndex: "updatedAt",
            width: 150,
            key: "updatedAt",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
        },
    ];

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    const [initialLoad, setInitialLoad] = useState(true)

    const [page, setPage] = useState({
        current: 1,
        pageSize: 50,
        total: 10,
    });



    const [sort, setSort] = useState({
        name: "",
        type: ""
    });

    const [search, setSearch] = useState("")

    const handleDownload = async (id, name) => {


        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");

            axios
                .get(
                    configData.SERVER_URL +
                    `adsTxt/downloadDomain?type=pub&_id=` + id,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "x-access-token": token,
                        },
                    }
                )
                .then((response) => {
                    const blob = new Blob([response.data], {
                        type: "text/csv;charset=utf-8",
                    });
                    saveAs(blob, name + ".csv");
                })
                .catch((error) => { });
        }
    };


    const getData = () => {
        setLoading(true)
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            axios
                .get(configData.SERVER_URL + `adsTxt/pubDomainListing?sort=${sort.name}&order=${sort.type}&search=${search}&limit=${page.pageSize}&page=${page.current}`, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {
                    setData(response.data.data.data)
                    if (response.data.data.data.length > 0) {
                        let tempPage = { ...page }
                        tempPage.total = response.data.data.metaData?.totalRecords

                        setPage(tempPage)
                    }

                    setLoading(false)
                    setInitialLoad(false)
                })
                .catch((error) => {
                    setData([])
                    setLoading(false)
                    setInitialLoad(false)
                });
        }

    }

    useEffect(() => {
        TokenVerificationLoggedin();
        BlockAdmin()
        // let status = Cookies.get("token_xapads_ssp") ? true : false;
        // if (status) {
        //     let token = Cookies.get("token_xapads_ssp");
        // let checkRole = jwtDecode(token).role;
        // setCheckRole(checkRole)
        // }
        getData()
        loadingContext.done()
    }, [loadingContext]);



    useEffect(() => {
        if (!initialLoad) {
            getData()
        }
    }, [apiCall])

    useEffect(() => {
        if (!initialLoad) {
            const delayDebounceFn = setTimeout(() => {
                let tempPage = page
                tempPage.current = 1
                setPage(tempPage);
                setApicall(!apiCall)
            }, 400); // 500ms delay
            // Cleanup function to clear the timeout if query changes
            return () => clearTimeout(delayDebounceFn);
        }
    }, [search]);



    const handleTableChange = (pagination, filters, sorter) => {
        setSort({ name: sorter.field, type: sorter.order });
        setApicall(!apiCall)
    };

    const handlePageChange = (data) => {

        let tempPage = page
        tempPage.current = data
        setPage(tempPage);
        setApicall(!apiCall)
    };

    const handlePageSizeChange = (e) => {
        let tempPage = page
        tempPage.pageSize = e

        if (tempPage.current > 1) {
            if (e * tempPage.current > tempPage.total) {
                tempPage.current = tempPage.current - 1
            }
        }
        setPage(tempPage);
        setApicall(!apiCall)
    };

    const itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <Link><img src={prevIcon} alt='USP' /></Link>;
        }
        if (type === 'next') {
            return <Link><img src={nextIcon} alt='USP' /></Link>;
        }
        return originalElement;
    };


    const locale = {
        emptyText:
            <>{search.trim().length > 0 && loading ?
                <div className='no_data_screen'>
                    <div className='text-center'>

                        <div className='float_text_div'>

                        </div>
                    </div>
                </div>
                :
                search.trim().length > 0 && !loading ?
                    <div className='no_data_screen'>
                        <div className='text-center'>
                            <img src={errorData} className='' alt="" />
                            <div className='float_text_div'>

                            </div>
                        </div>
                    </div>
                    :

                    loading ?
                        <div className='no_data_screen'>
                            <div className='text-center'>

                                <div className='float_text_div'>

                                </div>
                            </div>
                        </div>
                        :
                        <div className='no_data_screen' >
                            <div className='text-center'>
                                <img src={noData} className='' alt="" />
                                <div className='float_text_div'>

                                </div>
                            </div>
                        </div>
            }
            </>

    };



    // /////////////////////////////////Info related modal code  ///////////////////////////////////
    // //////////////////////////////////////////////////Modal related States///////////////////////////////


    const [isModalVisible, setIsModalVisible] = useState(false);
    const [dataInfoModal, setDataInfoModal] = useState({});

    function resetModalStateDomainInfo() {
        setIsModalVisible(false);
        setDataInfoModal({})
    }

    return (
        <>


            <div className="container_box--wrapper pt_header">
                <div className="container_box--wrapper--title d_flex justify-content-between">
                    <h1 className="heading fw_600">
                        Domain History
                    </h1>
                </div>
                <div className={data.length > 0 ? "table_and_filter_div --without_filter_div" : "table_and_filter_div --without_filter_div --no_data_div_height"}>
                    <div className="table_area_div">
                        <div className="searchbar_with_btns">
                            <div className="d_flex justify_content_between  mb_10">
                                <div className="form_content_block--group">
                                    {!initialLoad &&
                                        <Input
                                            type='text'
                                            className='form_control basic md search_input w_table_search'
                                            placeholder="Search"
                                            value={search}
                                            onChange={(e) => {

                                                if (e.target.value.trim().length === 0) {
                                                    setLoading(true)
                                                }

                                                setSearch(e.target.value)
                                            }}
                                        />
                                    }
                                </div>
                                {/* <div className="custom_filter_design_d2">


                        <div className="column_hide_unhide_d2">
                            <Dropdown className="" autoClose="outside">
                                <Dropdown.Toggle id="dropdown-autoclose-outside">
                                    <img src={columnIcon} alt="" />
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <div className="colunm_checkbox">
                                        <ul className="p-0 m-0">

                                            <li>
                                                <label htmlFor="oneone">
                                                    <input className="form-check-input" type="checkbox" id="oneone"
                                                        checked={colvis.z_cate}
                                                        onChange={() => {
                                                            let tempData = { ...colvis }
                                                            tempData.z_cate = !tempData.z_cate
                                                            setColvis(tempData)
                                                        }}
                                                    /> <span>Category</span>
                                                </label>
                                            </li>
                                            <li>
                                                <label htmlFor="twotwo">
                                                    <input className="form-check-input" type="checkbox" id="twotwo"
                                                        checked={colvis.invent_type}
                                                        onChange={() => {
                                                            let tempData = { ...colvis }
                                                            tempData.invent_type = !tempData.invent_type
                                                            setColvis(tempData)
                                                        }}
                                                    /> <span>Inventory Type</span>
                                                </label>
                                            </li>
                                            <li>
                                                <label htmlFor="three">
                                                    <input className="form-check-input" type="checkbox" id="three"
                                                        checked={colvis.p_name}
                                                        onChange={() => {
                                                            let tempData = { ...colvis }
                                                            tempData.p_name = !tempData.p_name
                                                            setColvis(tempData)
                                                        }}
                                                    /> <span>Publisher</span>
                                                </label>
                                            </li>
                                            <li>
                                                <label htmlFor="four">
                                                    <input className="form-check-input" type="checkbox" id="four"
                                                        checked={colvis.createdAt}
                                                        onChange={() => {
                                                            let tempData = { ...colvis }
                                                            tempData.createdAt = !tempData.createdAt
                                                            setColvis(tempData)
                                                        }}
                                                    /> <span>Created At</span>
                                                </label>
                                            </li>

                                        </ul>
                                    </div>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div> */}

                            </div>
                        </div>
                        <div className="table_content--box --new_layout_table_design table_empty_screen_d2">
                            {loading && !initialLoad &&
                                <div className="table_new_loader_d2">
                                    <img src={FullLoader} className="img-fluid" alt="" />
                                </div>
                            }

                            {initialLoad ?
                                <TableLoader />

                                :
                                <Table
                                    columns={columnsAll}
                                    pageSize={100}
                                    dataSource={data}
                                    onChange={handleTableChange}
                                    pagination={false}
                                    rowKey={(record) => record.id}
                                    locale={locale}
                                    scroll={{ x: 1500, y: 'calc(100vh - 30.9rem' }} />


                            }

                            {data.length > 0 &&
                                <Row className="custom_pagination--container">
                                    <Col span={6}>
                                        <div className="form_content_block--group mb_0">
                                            <Select
                                                className='form_select basic sm no_search'
                                                value={page.pageSize}
                                                onChange={handlePageSizeChange}
                                                style={{ width: 80 }}
                                                showSearch={false}
                                                options={[
                                                    { value: 10, label: 10 },
                                                    { value: 20, label: 20 },
                                                    { value: 50, label: 50 },
                                                    { value: 100, label: 100 },
                                                ]} />
                                            <label className='custom_pagination--label'>
                                                items per page
                                            </label>
                                        </div>
                                    </Col>
                                    <Col span={6}>
                                        <span className="custom_pagination--total-text">
                                            {`${(page.current - 1) * page.pageSize + 1}-${Math.min(page.current * page.pageSize, page.total)} of ${page.total} items`}
                                        </span>
                                    </Col>
                                    <Col span={6}>
                                        <Pagination
                                            current={page.current}  // Pass individual props instead of spreading them
                                            pageSize={page.pageSize}
                                            total={page.total}
                                            onChange={handlePageChange}
                                            showSizeChanger={false}
                                            itemRender={itemRender}
                                            className="custom_pagination" />
                                    </Col>
                                </Row>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                className='custom_modal custom_modal_form_d2'
                visible={isModalVisible}
                onOk={resetModalStateDomainInfo}
                width={1080}
                onCancel={resetModalStateDomainInfo}
                maskClosable={false}
                title={
                    <div className='custom_modal--header'><h3 className='heading'><img src={macrosicon} alt='USP' /> Domain Details</h3>
                    </div>
                }
                closable={true} // This removes the default close button
                footer={[]}
            >
                <div className="custom_modal--body">
                    <div className='all_macros_tag_d2 scrollable_tooltip_data_div_d2'>

                        <Row gutter={8}>
                            <Col span={24}>
                                <ul>
                                    <li>
                                        Uploaded Domain Count - <span>    {dataInfoModal["UPLOADED DOMAIN COUNT"] === undefined ? <>-</> : dataInfoModal["UPLOADED DOMAIN COUNT"]}
                                        </span>
                                    </li>
                                </ul>
                            </Col>
                        </Row>

                        <Row gutter={8}>
                            <Col span={24}>
                                <ul>
                                    <li>
                                        New Domain Count - <span>    {dataInfoModal["UNIQUE DOMAIN COUNT"] === undefined ? <>-</> : dataInfoModal["UNIQUE DOMAIN COUNT"]}
                                        </span>
                                    </li>
                                </ul>
                            </Col>

                        </Row>

                        <Row gutter={8}>
                            <Col span={24}>
                                <ul>
                                    <li>
                                        Already Exist Domain Count - <span>    {dataInfoModal["ALREADY EXIST DOMAIN COUNT"] === undefined ? <>-</> : dataInfoModal["ALREADY EXIST DOMAIN COUNT"]}
                                        </span>
                                    </li>
                                </ul>
                            </Col>

                        </Row>

                        <Row gutter={8}>
                            <Col span={24}>
                                <ul>
                                    <li>
                                        Error URLs Count - <span>    {dataInfoModal["ERROR URLs COUNT"] === undefined ? <>-</> : dataInfoModal["ERROR URLs COUNT"]}
                                        </span>
                                    </li>
                                </ul>
                            </Col>

                        </Row>

                        <Row gutter={8}>
                            <Col span={24}>
                                <ul>
                                    <li>
                                        DB Insertion Error URLs Count - <span>    {dataInfoModal["DB INSERTION ERROR URLs COUNT"] === undefined ? <>-</> : dataInfoModal["DB INSERTION ERROR URLs COUNT"]}
                                        </span>
                                    </li>
                                </ul>
                            </Col>

                        </Row>

                        <Row gutter={8}>
                            <Col span={24}>
                                <ul>
                                    <li>
                                        DB Insert Error With Success:TRUE Counter Error URLs Count - <span>   {dataInfoModal["DB INSERT ERROR WITH SUCCESS:TRUE COUNT"] === undefined ? <>-</> : dataInfoModal["DB INSERT ERROR WITH SUCCESS:TRUE COUNT"]}
                                        </span>
                                    </li>
                                </ul>
                            </Col>

                        </Row>

                        <Row gutter={8}>
                            <Col span={24}>
                                <ul>
                                    <li>
                                        DB Insert Error With Success:FALSE Count - <span>     {dataInfoModal["DB INSERT ERROR WITH SUCCESS:FALSE COUNT"] === undefined ? <>-</> : dataInfoModal["DB INSERT ERROR WITH SUCCESS:FALSE COUNT"]}
                                        </span>
                                    </li>
                                </ul>
                            </Col>

                        </Row>
                        <Row gutter={8}>
                            <Col span={24}>
                                <ul>
                                    <li>
                                        Success URLs Count - <span>     {dataInfoModal["SUCCESS URLs COUNT"] === undefined ? <>-</> : dataInfoModal["SUCCESS URLs COUNT"]}
                                        </span>
                                    </li>
                                </ul>
                            </Col>

                        </Row>
                        <Row gutter={8}>
                            <Col span={24}>
                                <ul>
                                    <li>
                                        DB Insertion Success URLs Count -<span>    {dataInfoModal["DB INSERTION SUCCESS URLs COUNT"] === undefined ? <>-</> : dataInfoModal["DB INSERTION SUCCESS URLs COUNT"]}
                                        </span>
                                    </li>
                                </ul>
                            </Col>

                        </Row>
                        <Row gutter={8}>
                            <Col span={24}>
                                <ul>
                                    <li>
                                        DB Insert Success With Success:TRUE Count - <span>    {dataInfoModal["DB INSERT SUCCESS WITH SUCCESS:TRUE COUNT"] === undefined ? <>-</> : dataInfoModal["DB INSERT SUCCESS WITH SUCCESS:TRUE COUNT"]}
                                        </span>
                                    </li>
                                </ul>
                            </Col>

                        </Row>
                        <Row gutter={8}>
                            <Col span={24}>
                                <ul>
                                    <li>
                                        DB Insert Success With Success:FALSE Count – <span> {dataInfoModal["DB INSERT SUCCESS WITH SUCCESS:FALSE COUNT"] === undefined ? <>-</> : dataInfoModal["DB INSERT SUCCESS WITH SUCCESS:FALSE COUNT"]}
                                        </span>
                                    </li>
                                </ul>
                            </Col>

                        </Row>

                        <Row gutter={8}>
                            <Col span={24}>
                                <ul>
                                    <li>
                                        DB Insert Success With Success:FALSE URLs – <span>
                                            {
                                                dataInfoModal["DB INSERT SUCCESS WITH SUCCESS:FALSE URLs"] === undefined || dataInfoModal["DB INSERT SUCCESS WITH SUCCESS:FALSE URLs"].length === 0 ? <>NA</> : JSON.stringify(dataInfoModal["DB INSERT SUCCESS WITH SUCCESS:FALSE URLs"])
                                            }

                                        </span>
                                    </li>
                                </ul>
                            </Col>

                        </Row>
                        <Row gutter={24}>

                            <Col span={24}>
                                <ul>
                                    <li>
                                        DB Insert Error With Success:FALSE URLs – <span>

                                            {
                                                dataInfoModal["DB INSERT ERROR WITH SUCCESS:FALSE URLs"] === undefined || dataInfoModal["DB INSERT ERROR WITH SUCCESS:FALSE URLs"].length === 0 ? <>NA</> : JSON.stringify(dataInfoModal["DB INSERT ERROR WITH SUCCESS:FALSE URLs"])
                                            }

                                        </span>
                                    </li>
                                </ul>
                            </Col>
                        </Row>


                    </div>
                </div>
            </Modal>
        </>
    );
};

export default AdminDomainList;
